<template>
  <div>
    <vuex-table
      :fields="fields"
      :auto_start="false"
      :show_per_page="false"
      table_store="phone-number/stats/general"
    >
      <template>
        <div>
          <slot name="head" :title="$attrs.title">
            <div>{{ $attrs.title }}</div>
          </slot>
        </div>
      </template>

      <template slot="average_subscription_fee" slot-scope="{ item }">
        <div>{{ $numeral.currency(item.average_subscription_fee) }}</div>
        <div class="text-grey">
          {{ $tc('phone-number.stats.general.cell.fee', item.subscription_fee_count) }}
        </div>
      </template>

      <template slot="subscription_fee_sum" slot-scope="{ item }">
        <div>{{ $numeral.currency(item.subscription_fee_sum) }}</div>
        <div class="text-grey">
          {{ $tc('phone-number.stats.general.cell.fee', item.connection_count) }}
        </div>
      </template>

      <!-- hack for cell in column  -->
      <template slot="group_by" slot-scope="{ item }">
        <div v-if="item.group_by === 'total'">
          {{ $tc('phone-number.stats.general.field.total') }}
        </div>
      </template>
    </vuex-table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import moment from 'moment-es6';

  export default {
    computed: {
      ...mapGetters('phone-number/stats/general', ['filter']),

      fields: function () {
        return [
          {
            key: 'group_by',
            label:
              this.filter.group_by === 'month'
                ? this.$t('phone-number.stats.general.field.month')
                : this.$t('phone-number.stats.general.field.country'),
            sortable: false,
            class: 'column-sticky',
            thStyle: {
              minWidth: '100px'
            },
            formatter: (val) => {
              if (this.filter.group_by === 'month') {
                return moment(val).format('MMMM YYYY');
              }
              return val
            }
          },

          {
            key: 'number_count',
            label: this.$t('phone-number.stats.general.field.number_count'),
            sortable: false,
            thStyle: {
              minWidth: '150px'
            },
            tooltip: this.$t('phone-number.number.tooltips.all_number_period')
          },

          {
            key: 'subscription_fee_sum',
            label: this.$t('phone-number.stats.general.field.subscription_fee_sum'),
            sortable: false,
            formatter: (val) => this.$numeral.currency(val),
            thStyle: {
              minWidth: '180px'
            },
            tooltip: this.$t('phone-number.number.tooltips.cost_period')
          },

          {
            key: 'average_subscription_fee',
            label: this.$t('phone-number.stats.general.field.average_subscription_fee'),
            formatter: (val) => this.$numeral.currency(val),
            sortable: false,
            tooltip: this.$t('phone-number.number.tooltips.average_period')
          },

          {
            key: 'connection_cost_sum',
            label: this.$t('phone-number.stats.general.field.connection_cost_sum'),
            formatter: (val) => this.$numeral.currency(val),
            sortable: false
          }
        ];
      }
    }
  };
</script>
